import { connect } from 'react-redux';

import adminActions from '_store/_actions/admin';

import BillingOverview from './BillingOverview';

const mapStateToProps = state => {
  const { billingOverview, isLoadingBillingOverview } = state.admin;

  return {
    billingOverview,
    isLoading: isLoadingBillingOverview,
  };
};

const mapDispatchToProps = {
  onFetchBillingOverview: adminActions.fetchAdminBillingOverview,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingOverview);
